import React from 'react';
import { Box, Card, CardContent, Chip, Stack, Typography } from '@mui/material'
import { IconPicker } from '../../../display-elements-components/icon-picker';
import { IconName } from '../../../../../shared/interfaces/icon-picker.model';
import { CheckCircleOutline, Checklist } from '@mui/icons-material';

export const EmissionsGroupCard: React.FC<{
  icon: IconName,
  title: string,
  description: string,
  actionsCompleted?: number,
  actionsTotal: number,
  isInactive?: boolean,
  clickHandler?: () => void,
  showCompletedTick?: boolean,
  // The group's total for the period, already formatted, and for Scope 2 the basis it is on.
  totalLabel?: string | null,
  totalBasisLabel?: string | null,
}> = ({
  icon,
  title,
  description,
  actionsCompleted,
  actionsTotal,
  isInactive = false,
  clickHandler,
  showCompletedTick,
  totalLabel,
  totalBasisLabel
}) => {
    return (
      <Card onClick={clickHandler} sx={{
        height: '100%', boxShadow: 'none', borderWidth: '1px', borderStyle: 'solid', borderColor: 'lightGrey.main', borderRadius: '10px', backgroundColor: isInactive ? 'lightGrey.light' : 'common.white', cursor: isInactive ? 'default' : 'pointer',
      }}>
        <CardContent sx={{ height: '100%', position: 'relative' }}>
          {showCompletedTick === true &&
            <CheckCircleOutline sx={{ color: 'primary.main', top: 15, right: 15, position: 'absolute' }} />
          }
          <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'start', gap: 3, mr: 4, p: 1 }}>
            <Box sx={{ pt: 0.5, color: 'text.secondary' }}>
              <IconPicker icon={icon} />
            </Box>
            <Stack sx={{ flexGrow: 1 }}>
              <Typography variant='subtitle1' sx={{ fontWeight: 600, color: 'text.primary' }}>
                {title}
              </Typography>
              <Typography variant='body2' sx={{ color: 'text.secondary', pb: 1 }}>
                {description}
              </Typography>
              <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1}>
                {actionsTotal > 0 &&
                  <Chip
                    color={actionsCompleted !== actionsTotal ? 'default' : 'primary'}
                    icon={<Checklist fontSize='small' />}
                    label={`${actionsCompleted} / ${actionsTotal}`}
                    sx={{ width: '90px', color: actionsCompleted !== actionsTotal ? 'text.primary' : 'white' }} />}
                {totalLabel &&
                  <Chip
                    variant='outlined'
                    label={totalBasisLabel ? `${totalLabel} · ${totalBasisLabel}` : totalLabel}
                    sx={{ color: 'text.primary', fontWeight: 600 }} />}
              </Stack>
            </Stack>
          </Box>
        </CardContent>
      </Card >
    )
  }